<form class="quick-form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label class="form-label" for="qcf-name">Nome completo</label>
    <input
      id="qcf-name"
      type="text"
      class="form-input"
      formControlName="name"
      placeholder="Digite seu nome completo"
      maxlength="255"
    />
    @if (form.get('name')?.invalid && form.get('name')?.touched) {
      <span class="error-message">Nome é obrigatório</span>
    }
  </div>

  <div class="form-group">
    <label class="form-label" for="qcf-email">E-mail</label>
    <input
      id="qcf-email"
      type="email"
      class="form-input"
      formControlName="email"
      placeholder="seu@email.com"
    />
    @if (form.get('email')?.invalid && form.get('email')?.touched) {
      <span class="error-message">
        @if (form.get('email')?.errors?.['required']) {
          E-mail é obrigatório
        } @else if (form.get('email')?.errors?.['email']) {
          E-mail inválido
        }
      </span>
    }
  </div>

  <div class="form-group">
    <label class="form-label" for="qcf-phone">Número de telefone</label>
    <app-phone-country-input inputId="qcf-phone" formControlName="phone" />
  </div>

  <div class="form-group">
    <label class="form-label" for="qcf-message">Mensagem (opcional)</label>
    <textarea
      id="qcf-message"
      class="form-textarea"
      formControlName="message"
      placeholder="Conte um pouco sobre o que procura..."
      rows="3"
      maxlength="400"
    ></textarea>
    @if (form.get('message')?.invalid && form.get('message')?.touched) {
      <span class="error-message">Mensagem muito longa (máximo 400 caracteres)</span>
    }
  </div>

  <button type="submit" class="btn-submit" [disabled]="isLoading()">
    {{ isLoading() ? 'Enviando...' : 'Entrar em contato' }}
  </button>
</form>
